// Common constants used by CommonLayout components
// Moved from HomePage to remove cross-dependencies

export enum ScrollTypeEnum {
  DEVELOP_SCREEN_ID = "develop-screen",
  HOME_DIFFERENT_ID = "home-different",
  HOME_FELLOU_WORK_ID = "home-fellou-work",
  STORIES_SCREEN_ID = "stories-screen",
}